const hostname = window && window.location && window.location.hostname

const mainURL = 'https://api.top-court.com/merchant'
// const stagingURL = 'https://staging-api.top-court.com/admin'
const stagingURL = 'http://localhost:5100/merchant'
const betaURL = 'https://api-beta.top-court.com/merchant'

let adminUrl = mainURL

console.log('hostname', hostname)

if (hostname) {
    if (hostname.includes('beta-topcourtmerchant.netlify.app')) {
        adminUrl = betaURL
    } else if (hostname.includes('staging-merchant.top-court.com')) {
        adminUrl = stagingURL
    } else if (hostname.includes('merchant.top-court.com')) {
        adminUrl = mainURL
    } else if (hostname.includes('localhost')) {
        adminUrl = stagingURL
    }
}

console.log('hostname', hostname, adminUrl)

export {
    adminUrl
}